import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { FsAssignment } from './assignments';

export class SnCallSign extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public team: string;

  @Expose()
  public assignments: FsAssignment[];

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
